module.exports = __webpack_public_path__ + "static/Sushasan_li_logo-658b9b93c9108e44c9246b75d2087a98.png";